<script setup lang="ts">
    withDefaults(
        defineProps<{
            cssClass?: string;
        }>(),
        { cssClass: 'pa-10' },
    );
</script>

<template>
    <v-card class="app-card bg-surface" variant="outlined" :class="cssClass">
        <slot></slot>
    </v-card>
</template>

<style scoped lang="scss">
    .app-card {
        border-radius: 12px;
        border: 1px solid rgb(var(--v-theme-grey-light-1));
        margin-bottom: 20px;
        max-width: 1020px;
    }
</style>
